export const ROW_HEIGHT = "80px";
